// client/src/components/login/ForgotPasswordForm.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './ForgotPasswordForm.css';

function ForgotPasswordForm() {
    const { t, i18n } = useTranslation();
    const [username, setUsername] = useState('');
    const [usernameError, setUsernameError] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    // --- Add new state variable ---
    const [isSubmittedSuccessfully, setIsSubmittedSuccessfully] = useState(false);

    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
        setUsernameError(''); // Clear error on change
        // Optional: Allow re-typing if already submitted? If not, add check:
        // if (isSubmittedSuccessfully) return;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Don't allow submission if already successful
        if (isSubmittedSuccessfully) return;

        setError('');
        setMessage('');
        setUsernameError('');

        if (!username) {
            setUsernameError(t('ForgotPassword.errors.usernameRequired'));
            return;
        }
        //Basic validation
        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(username);
        if (!isEmail && !/^\d{9,}$/.test(username)) {
            setUsernameError(t('ForgotPassword.errors.invalidUsername'));
            return;
        }

        // Note: Using 'fetch' as per the user's last provided code for this file.
        // If other parts use 'axios' from 'authApi.js', consider consistency.
        try {
            const response = await fetch('/api/auth/forgot-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username: username, language: i18n.language }),
            });

            // --- Check if response is OK ---
            if (response.ok) {
                const data = await response.json();
                setMessage(data.message || t('ForgotPassword.successMessageDefault')); // Use server message or a default success message
                setError('');
                // --- Set submitted state to true on success ---
                setIsSubmittedSuccessfully(true);
            } else {
                // Handle errors from the server
                const data = await response.json();
                setError(data.message || t('ForgotPassword.errors.unexpectedError')); // Use server message or a default error
                setMessage('');
            }

        } catch (err) {
            console.error("Error submitting forgot password request:", err);
            setError(t('ForgotPassword.errors.networkError')); // Specific error for network issues
            setMessage('');
        }
    };

    return (
        <div className="forgot-password-form">
            <h2 className="forgot-password-form__title">{t('ForgotPassword.forgotPasswordTitle')}</h2>
            {/* <p className="forgot-password-form__instructions">{t('ForgotPassword.forgotPasswordInstructions')}</p> */}

            <form onSubmit={handleSubmit}>
                <div className="forgot-password-form__group">
                    <label htmlFor="username" className="forgot-password-form__label">{t('ForgotPassword.usernameLabel')}</label>
                    <input
                        type="text"
                        id="username"
                        name="username"
                        value={username}
                        onChange={handleUsernameChange}
                        placeholder={t('ForgotPassword.usernamePlaceholder')}
                        className={`forgot-password-form__input ${usernameError ? 'forgot-password-form__input--error' : ''}`}
                        // --- Disable input if submitted successfully ---
                        disabled={isSubmittedSuccessfully}
                        aria-invalid={!!usernameError}
                        aria-describedby={usernameError ? "username-error-msg" : undefined}
                    />
                    {usernameError && <div id="username-error-msg" className="forgot-password-form__error">{usernameError}</div>}
                </div>

                {/* Display error or success message */}
                {error && <div className="forgot-password-form__error">{error}</div>}
                {message && <div className="forgot-password-form__message">{message}</div>}

                <button
                    type="submit"
                    className="forgot-password-form__button"
                    // --- Disable button if submitted successfully ---
                    disabled={isSubmittedSuccessfully}
                >
                    {/* Show different text if already submitted */}
                    {isSubmittedSuccessfully ? t('ForgotPassword.resetPasswordButton') : t('ForgotPassword.resetPasswordButton')}
                </button>

                <div className="forgot-password-form__login-link">
                    <Link to="/login">{t('ForgotPassword.returnToLogin')}</Link>
                </div>
            </form>
        </div>
    );
}

export default ForgotPasswordForm;